import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./transport.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const TransportAndLogistics = () => {
  return (
    <div className="transport-industry-wrapper">
      <Particles title="Transport And Logistics" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default TransportAndLogistics;
